import { render, staticRenderFns } from "./MeetingCard.vue?vue&type=template&id=44b81b65"
import script from "./MeetingCard.vue?vue&type=script&lang=js"
export * from "./MeetingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports